import { useState, useEffect, Fragment } from "react";
import { Box, Button, Typography, Grid, Stack } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import MpgItem from "../../../../../CommonFormComp/MpgItem";
import MpgAutocompleteSingle from "../../../../../CommonFormComp/MpgAutocompleteSingle";
import { createClientAccPDValidation } from "./createClientAccPDValidation";
import CircularProgress from "@mui/material/CircularProgress";
import { useGetSignedInUserDetails } from "../../../../../hooksAndFunctions/customHooks/useGetSignedInUserDetails";
import { clientAccPDViewPath } from "../../../../../routes/routePaths";
import MpgLoadingDialog from "../../../../../common/dialog/MpgLoadingDialog";
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";
import { useGetLoggedInUserDetails } from "../../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import ClientAccPDDataTable from "../clientAccPDTableComp/ClientAccPDDataTable";
import { useCreateClientAccPDMutation, useViewClientAccoundPDListMutation } from "../../../../../reactQueries/AppApi/rqHooksForClientAccProgrammeDescriptor";
import { useViewProgrammeDescriptorListMutation } from "../../../../../reactQueries/AppApi/rqHooksForProgrammeDescriptor";
import MpgProgrammeDescriptorDialog from "../../../../../CommonFormComp/MpgProgrammeDescriptorListDialog/MpgProgrammeDescriptorDialog";
import { useGetClientAccountDropdownMutation } from "../../../../../reactQueries/AppApi/rqHooksForClientUsers";
import MpgPsudoInput from "../../../../../CommonFormComp/MpgPsudoInput";
import UploadAndCreateCustomPD from "../../uploadAndCreateCustomPD/UploadAndCreateCustomPD";
import { getAccessTypes } from "../../../../../hooksAndFunctions/functions/getAccessTypes"
import { useGetAccountAndSubAccListOnlyForA4Role } from "../../../../../hooksAndFunctions/customHooks/useGetAccountAndSubAccListOnlyForA4Role";

const CreateClientAccPD = () => {
  const navigate = useNavigate();
  const { userName } = useGetSignedInUserDetails();

  const { loggedInUser } = useGetLoggedInUserDetails();
  const { emailAddress, clientPortalAdminRoleId, isEnterpriseAdmin, id: userId } = loggedInUser;

  const {
    clientPortalAdminType
  } = getAccessTypes()
  const {
    hasA2Access,
    hasA4Access
  } = clientPortalAdminType

  // console.log("loggedInUser", loggedInUser)

  /** !!!!!!!! form handling  !!!!!!!! */

  const { schema } = createClientAccPDValidation();

  const rhfFormInstance = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      pdList: ""
    }
  });

  const { watch, setValue } = rhfFormInstance;

  const clientAcc = watch("client_account")
  const selectedClientAccId = clientAcc?.id

  /** !!!!!!!! API calls  !!!!!!!! */

  // api - create report resource mutation
  const {
    mutate: createClientAccProgrammeDescriptor,
    isError: isErrorOnCreate,
    isLoading: isLoadingOnCreate,
    isSuccess: isSuccessOnCreate,
    error: errorOnCreate,
  } = useCreateClientAccPDMutation();


  //api - get client accounts list
  const { mutate: getClientAccountList,
    data: clientAccountList } = useGetClientAccountDropdownMutation()

  useEffect(() => {
    getClientAccountList({ loggedInUserId: userId, roleId: clientPortalAdminRoleId, isEnterpriseAdmin })
  }, [loggedInUser])

  const roleBasedClientAccountListData = clientAccountList?.data

  const { mutate: getPDList, data: PDData, isLoading: isLoadingOnPDData, } = useViewProgrammeDescriptorListMutation();

  useEffect(() => {
    getPDList({ loggedInUserId: userId, roleId: clientPortalAdminRoleId, isEnterpriseAdmin })
  }, [loggedInUser])

  let filteredPDListForStandardType = PDData?.data?.filter(eachItem => eachItem?.ProgramDescripitorType === "Standard") || [];
  /** grab collection of client accounts where PD is mapped */
  const {
    mutate: getAllClientAccPDList,
    data: clientPDData  } = useViewClientAccoundPDListMutation();

  useEffect(() => {
    getAllClientAccPDList({ loggedInUserId: userId, roleId: clientPortalAdminRoleId, isEnterpriseAdmin })
  }, [loggedInUser])

  let listOfClientAccIdsHavingPDs = clientPDData?.data?.map(eachClientPDData => eachClientPDData?.ClientAccountId) || [];

  /**
   * client account drop down for A4 role
   */
  const { clientAccListForA4Role } = useGetAccountAndSubAccListOnlyForA4Role({ userId })
  const clientAccAutocompleteListForA4Role = clientAccListForA4Role?.map(item => ({
    id: item.Id,
    selectOptionLabel: `${item.AccountName}`,
    selectOptionValue: item.Id,
    extraData: item,
  })) || [];
  /**list of inactive client acc */
  let listOfInactiveClientAccIdsForA4Roleonly = clientAccListForA4Role
  ?.filter(item => !item.IsActive)
  .map(item => item.Id) || [];
  /**
* client account drop down for rest of roles
*/
  const roleBasedClientAccountAutocomleteListData = roleBasedClientAccountListData?.map(item => ({
      id: item.Id,
      selectOptionLabel: `${item.ClientAccountName}`,
      selectOptionValue: item.Id,
      extraData: item,
    })) || [];
  /**list of inactive client acc */
  let listOfInactiveClientAccIdsForRestOfRoles = roleBasedClientAccountListData
  ?.filter(item => !item.IsActive)
  .map(item => item.Id) || [];

  /** !!!!! handling standard PD dialog !!!!!!!! */
  const [openPDDialog, setOpenPDDialog] = useState(false);

  /**PD data added into table */
  const [addedPDData, setAddedPDData] = useState([])

  // console.log("addedPDData", addedPDData)

  /**handling pdList data for table validation */
  useEffect(() => {
    if (!!addedPDData && !!addedPDData.length) {
      let idForFirstElement = addedPDData[0]?.Id
      setValue("pdList", idForFirstElement);
    } else {
      setValue("pdList", "");
    }
  }, [addedPDData])

  /** !!!!!!!! handling submit function  !!!!!!!! */

  const onSubmit = (data) => {
    let programmeDescriptorsList = [];
    if (!!addedPDData && !!addedPDData.length) {
      addedPDData.forEach((item) => {
        programmeDescriptorsList.push({
          ProgramDescripitorId: item?.Id,
          ClientAccountProgramDescripitorTitle: item?.clientAccPDTitle,
          ProgramDescripitorTitle: item?.ProgramDescripitorTitle,
          ProgramDescripitorType: item?.ProgramDescripitorType,
          TobeDeleted: !!item?.TobeDeleted ? true : false
        });
      });
    }

    const body = {
      ClientAccountId: data?.client_account?.id || "",
      ProgramDescriptors: programmeDescriptorsList || [],
      CreatedBy: emailAddress || ""
    };

    createClientAccProgrammeDescriptor({ body });
  };

  useEffect(() => {
    if (!!isSuccessOnCreate) {
      navigate(clientAccPDViewPath);
    }
  }, [isSuccessOnCreate]);

  /** disable options in client account dropdown if
   * 1. client account is inactive,
   * 2. client account has PD mapped,
   */
  const getListOfInactiveClientAccIdsAndClientAccIdsHavingPDs = ({ ListOfInactiveClientAccIds, ListOfClientAccIdsHavingPDs }) => {

    const mergedArray = [...ListOfInactiveClientAccIds, ...ListOfClientAccIdsHavingPDs]
    const set = new Set(mergedArray)

    const arrayWithUniqueItems = Array.from(set)

    return arrayWithUniqueItems
  }
  const disabledOptionIdsForA4Role = getListOfInactiveClientAccIdsAndClientAccIdsHavingPDs({
  ListOfInactiveClientAccIds: listOfInactiveClientAccIdsForA4Roleonly,
  ListOfClientAccIdsHavingPDs: listOfClientAccIdsHavingPDs
});
  const disabledOptionIdsForRestOfRoles = getListOfInactiveClientAccIdsAndClientAccIdsHavingPDs({
  ListOfInactiveClientAccIds: listOfInactiveClientAccIdsForRestOfRoles,
  ListOfClientAccIdsHavingPDs: listOfClientAccIdsHavingPDs
});
  /**handling custom resources */
  const [openCustomResource, setOpenCustomResource] = useState(false)

  const resourcesCMSData = useOutletContext();

  const fetchClientAccResDtlsLabel = (key) => {
    if (resourcesCMSData && resourcesCMSData?.pageContent["ClientAccountResourcesDetails"]) {
      const resourcesCMSDataLabel = resourcesCMSData.pageContent["ClientAccountResourcesDetails"];
      return returnLabel(resourcesCMSDataLabel?.Labels, key)
    }
  }

  const fetchCommonCMSLabel = (key) => {
    if (resourcesCMSData && resourcesCMSData?.pageContent["CommonComponent"]) {
        const commonCMSDataLabel = resourcesCMSData.pageContent["CommonComponent"];
        return returnLabel(commonCMSDataLabel?.Labels, key)
    }
    return '';
  }

  const returnLabel = (labelArray, key) => {
    if (labelArray.length > 0 && key) {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }
    return '';
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h5" align="center" sx={{ fontWeight: "bolder" }}>
        {/* Add Resources for Client Account */}
        {resourcesCMSData?.pageContent["ClientAccountResourcesDetails"]?.Title}
      </Typography>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        m={1}
      >
        <Button
          variant="outlined"
          size="small"
          component={Link}
          to={clientAccPDViewPath}
        >
          {/* Client Account Resources */}
          {fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ClientAccountResources')}
        </Button>
      </Stack>


      <Box
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={rhfFormInstance.handleSubmit(onSubmit)}
      >

        <MpgItem>
          <MpgAutocompleteSingle
            rhfFormInstance={rhfFormInstance}
            name={"client_account"}
            label={fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ClientAccount')} //"Client Account"
            fullWidth
            optionList={(hasA4Access || hasA2Access) ? clientAccAutocompleteListForA4Role : roleBasedClientAccountAutocomleteListData}
            disabledOptionIdArray={hasA4Access ? disabledOptionIdsForA4Role : disabledOptionIdsForRestOfRoles}
          />

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{
              m: "20px"
            }}
          >
            <div>
              <Button
                onClick={() => {
                  setOpenPDDialog(true);
                }}
                disabled={
                  !!isLoadingOnPDData
                }
                sx={{ m: "5px", backgroundColor: '#d6deff' }}
              >
                {isLoadingOnPDData ? (
                  <Fragment>
                    <CircularProgress size={15} sx={{ margin: "5px" }} />
                    {/* Fetching... */}
                    {fetchCommonCMSLabel('Common.Fetching')}
                  </Fragment>
                ) : (
                  <Fragment>
                    {fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.SelectStandardResource') /* Select Standard Resource */}
                  </Fragment>
                )}
              </Button>
            </div>

            <Button
              onClick={() => {
                setOpenCustomResource(true)
              }}
              disabled={
                !selectedClientAccId
              }
              sx={{ m: "5px", backgroundColor: '#d6deff' }}
            >
              {fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.AddCustomResource') /* Add Custom Resource */}
            </Button>

          </Grid>

          <div>
            <MpgPsudoInput
              rhfFormInstance={rhfFormInstance}
              name={"pdList"}
              label= {fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.SelectedResourceList')} //{"Selected Resource List :"}
            />
            <ClientAccPDDataTable
              tableData={addedPDData}
              setTableData={setAddedPDData}
            />
          </div>
        </MpgItem>


        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-evenly"}
          mt={3}
        >
          <Button variant="outlined" type="submit" size="small">
            {fetchCommonCMSLabel('Common.Save')}
          </Button>
        </Stack>
      </Box>

      <MpgProgrammeDescriptorDialog
        open={openPDDialog}
        setOpen={setOpenPDDialog}

        addedPDData={addedPDData || []}
        setAddedPDData={setAddedPDData}

        PDListFromAPI={filteredPDListForStandardType || []}
      />

      {/* dialog to add custom resources */}
      <UploadAndCreateCustomPD
        open={openCustomResource}
        setOpen={setOpenCustomResource}

        addedPDData={addedPDData || []}
        setAddedPDData={setAddedPDData}
      />

      {/** error dialog on create action */}
      <MpgErrorDialog
        open={!!isErrorOnCreate}
        title={
            isErrorOnCreate && errorOnCreate?.response?.data === "ClientAccountIdExistsForPD"
              ? "Resources exist for selected client account. Try again...!"
              : ""
          }
        content={
            isErrorOnCreate && errorOnCreate?.response?.data === "ClientAccountIdExistsForPD"
              ? `"Resources for "${watch("client_account")?.selectOptionLabel}" account already exist in our records. Please, try again with different client account.`
              : ""
          }
      />

      <MpgLoadingDialog
        open={
          !!isLoadingOnCreate
        }
      />
    </Box >
  );
};

export default CreateClientAccPD;
